import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 0.532rem;
`
